import {
  type TOSAgreementSchema,
  getGetPharosUserTosPharosUserTOSGetQueryKey,
  updatePharosUserTosRoutePharosUserTOSPut,
  useGetPharosUserTosPharosUserTOSGet,
} from "@phc/common/gen/preferencesGen"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useSnackbar } from "notistack"

export const useGetUserTermsOfService = () => {
  return useGetPharosUserTosPharosUserTOSGet()
}

export const useUpdateUserTermsOfService = () => {
  const queryClient = useQueryClient()
  const { enqueueSnackbar } = useSnackbar()

  return useMutation({
    mutationFn: (variables: { tosAgreement: TOSAgreementSchema }) =>
      updatePharosUserTosRoutePharosUserTOSPut({
        tos_agreement: variables.tosAgreement,
      }),
    retry: 5,
    onError: (err: Error) => {
      enqueueSnackbar("Failed to accept terms of service agreement.", {
        variant: "error",
      })
      console.error(err)
    },
    onSuccess: () => {
      enqueueSnackbar("Accepted terms of service agreement", {
        variant: "success",
      })
      void queryClient.invalidateQueries({
        queryKey: getGetPharosUserTosPharosUserTOSGetQueryKey(),
      })
    },
  })
}
